"use strict";
/**
 * @packageDocumentation
 * @module harmony-utils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unit = exports.fromWei = exports.toWei = exports.hexToBN = exports.hexToNumber = exports.numberToHex = exports.strip0x = exports.add0xToString = exports.numToStr = exports.numberToString = exports.unitMap = exports.Units = void 0;
var tslib_1 = require("tslib");
var bn_js_1 = tslib_1.__importDefault(require("bn.js"));
var validators_1 = require("./validators");
var Units;
(function (Units) {
    Units["wei"] = "wei";
    Units["Kwei"] = "Kwei";
    Units["Mwei"] = "Mwei";
    Units["Gwei"] = "Gwei";
    Units["szabo"] = "szabo";
    Units["finney"] = "finney";
    Units["ether"] = "ether";
    Units["one"] = "one";
    Units["Kether"] = "Kether";
    Units["Mether"] = "Mether";
    Units["Gether"] = "Gether";
    Units["Tether"] = "Tether";
})(Units = exports.Units || (exports.Units = {}));
/** @hidden */
exports.unitMap = new Map([
    [Units.wei, '1'],
    [Units.Kwei, '1000'],
    [Units.Mwei, '1000000'],
    [Units.Gwei, '1000000000'],
    [Units.szabo, '1000000000000'],
    [Units.finney, '1000000000000000'],
    [Units.ether, '1000000000000000000'],
    [Units.one, '1000000000000000000'],
    [Units.Kether, '1000000000000000000000'],
    [Units.Mether, '1000000000000000000000000'],
    [Units.Gether, '1000000000000000000000000000'],
    [Units.Tether, '1000000000000000000000000000000'],
]);
/** @hidden */
var DEFAULT_OPTIONS = {
    pad: false,
};
/**
 * Convert Number to String
 */
exports.numberToString = function (obj, radix) {
    if (radix === void 0) { radix = 10; }
    if (bn_js_1.default.isBN(obj)) {
        return obj.toString(radix);
    }
    else if (validators_1.isNumber(obj)) {
        return new bn_js_1.default(obj).toString(radix);
    }
    else if (validators_1.isString(obj) && validators_1.isNumber(Number(obj))) {
        return new bn_js_1.default(obj).toString(radix);
    }
    else {
        throw new Error("cannot parse number:" + obj + " to string");
    }
};
/**
 * Convert Number to String
 */
exports.numToStr = function (input) {
    if (typeof input === 'string') {
        if (!input.match(/^-?[0-9.]+$/)) {
            throw new Error("while converting number to string, invalid number value '" + input + "', should be a number matching (^-?[0-9.]+).");
        }
        return input;
    }
    else if (typeof input === 'number') {
        return String(input);
    }
    else if (bn_js_1.default.isBN(input)) {
        return input.toString(10);
    }
    throw new Error("while converting number to string, invalid number value '" + input + "' type " + typeof input + ".");
};
exports.add0xToString = function (obj) {
    if (validators_1.isString(obj) && !obj.startsWith('-')) {
        return '0x' + obj.replace('0x', '');
    }
    else if (validators_1.isString(obj) && obj.startsWith('-')) {
        return '-0x' + obj.replace('-', '');
    }
    else {
        throw new Error(obj + " is not String");
    }
};
exports.strip0x = function (obj) {
    return obj.toLowerCase().replace('0x', '');
};
/**
 * Convert number to hex
 */
exports.numberToHex = function (obj) {
    try {
        return exports.add0xToString(exports.numberToString(obj, 16));
    }
    catch (error) {
        throw error;
    }
};
/**
 * Convert hex to Decimal number
 */
exports.hexToNumber = function (hex) {
    if (validators_1.isHex(hex) && hex[0] !== '-') {
        return new bn_js_1.default(exports.strip0x(hex), 'hex').toString();
    }
    else if (validators_1.isHex(hex) && hex[0] === '-') {
        var result = new bn_js_1.default(hex.substring(3), 16);
        return result.mul(new bn_js_1.default(-1)).toString();
    }
    else {
        throw new Error(hex + " is not hex number");
    }
};
/**
 * Convert hex to Big Number
 */
exports.hexToBN = function (hex) {
    if (validators_1.isHex(hex) && hex[0] !== '-') {
        return new bn_js_1.default(exports.strip0x(hex), 'hex');
    }
    else if (validators_1.isHex(hex) && hex[0] === '-') {
        var result = new bn_js_1.default(hex.substring(3), 16);
        return result.mul(new bn_js_1.default(-1));
    }
    else {
        throw new Error(hex + " is not hex number");
    }
};
/**
 * Converts any ONE value into wei
 */
exports.toWei = function (input, unit) {
    try {
        var inputStr = exports.numToStr(input);
        var baseStr = exports.unitMap.get(unit);
        if (!baseStr) {
            throw new Error("No unit of type " + unit + " exists.");
        }
        var baseNumDecimals = baseStr.length - 1;
        var base = new bn_js_1.default(baseStr, 10);
        // Is it negative?
        var isNegative = inputStr.substring(0, 1) === '-';
        if (isNegative) {
            inputStr = inputStr.substring(1);
        }
        if (inputStr === '.') {
            throw new Error("Cannot convert " + inputStr + " to wei.");
        }
        // Split it into a whole and fractional part
        var comps = inputStr.split('.'); // eslint-disable-line
        if (comps.length > 2) {
            throw new Error("Cannot convert " + inputStr + " to wei.");
        }
        var _a = tslib_1.__read(comps, 2), whole = _a[0], fraction = _a[1];
        if (!whole) {
            whole = '0';
        }
        if (!fraction) {
            fraction = '0';
        }
        if (fraction.length > baseNumDecimals) {
            throw new Error("Cannot convert " + inputStr + " to wei.");
        }
        while (fraction.length < baseNumDecimals) {
            fraction += '0';
        }
        var wholeBN = new bn_js_1.default(whole);
        var fractionBN = new bn_js_1.default(fraction);
        var wei = wholeBN.mul(base).add(fractionBN);
        if (isNegative) {
            wei = wei.neg();
        }
        return new bn_js_1.default(wei.toString(10), 10);
    }
    catch (error) {
        throw error;
    }
};
/**
 * Converts any wei value into a ONE value.
 */
exports.fromWei = function (wei, unit, options) {
    if (options === void 0) { options = DEFAULT_OPTIONS; }
    try {
        var weiBN = !bn_js_1.default.isBN(wei) ? new bn_js_1.default(wei) : wei;
        if (unit === 'wei') {
            return weiBN.toString(10);
        }
        var baseStr = exports.unitMap.get(unit);
        if (!baseStr) {
            throw new Error("No unit of type " + unit + " exists.");
        }
        var base = new bn_js_1.default(baseStr, 10);
        var baseNumDecimals = baseStr.length - 1;
        var fraction = weiBN
            .abs()
            .mod(base)
            .toString(10);
        // prepend 0s to the fraction half
        while (fraction.length < baseNumDecimals) {
            fraction = "0" + fraction;
        }
        if (!options.pad) {
            /* eslint-disable prefer-destructuring */
            var matchFraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/);
            fraction = matchFraction ? matchFraction[1] : '0';
        }
        var whole = weiBN.div(base).toString(10);
        return fraction === '0' ? "" + whole : whole + "." + fraction;
    }
    catch (error) {
        throw error;
    }
};
var Unit = /** @class */ (function () {
    function Unit(str) {
        if (!bn_js_1.default.isBN(str) && typeof str !== 'number' && validators_1.isHex(str)) {
            this.unit = exports.hexToNumber(str);
        }
        else if (!bn_js_1.default.isBN(str) && typeof str === 'number') {
            this.unit = str.toString();
        }
        else if (str === '0x') {
            this.unit = exports.hexToNumber('0x0');
        }
        else {
            this.unit = str;
        }
        this.wei = new bn_js_1.default(this.unit);
    }
    Unit.from = function (str) {
        return new Unit(str);
    };
    Unit.Wei = function (str) {
        return new Unit(str).asWei();
    };
    Unit.Kwei = function (str) {
        return new Unit(str).asKwei();
    };
    Unit.Mwei = function (str) {
        return new Unit(str).asMwei();
    };
    Unit.Gwei = function (str) {
        return new Unit(str).asGwei();
    };
    Unit.Szabo = function (str) {
        return new Unit(str).asSzabo();
    };
    Unit.Finney = function (str) {
        return new Unit(str).asFinney();
    };
    Unit.Ether = function (str) {
        return new Unit(str).asEther();
    };
    Unit.One = function (str) {
        return new Unit(str).asOne();
    };
    Unit.Kether = function (str) {
        return new Unit(str).asKether();
    };
    Unit.Mether = function (str) {
        return new Unit(str).asMether();
    };
    Unit.Gether = function (str) {
        return new Unit(str).asGether();
    };
    Unit.Tether = function (str) {
        return new Unit(str).asTether();
    };
    Unit.prototype.asWei = function () {
        this.wei = new bn_js_1.default(this.unit);
        return this;
    };
    Unit.prototype.asKwei = function () {
        this.wei = exports.toWei(this.unit, Units.Kwei);
        return this;
    };
    Unit.prototype.asMwei = function () {
        this.wei = exports.toWei(this.unit, Units.Mwei);
        return this;
    };
    Unit.prototype.asGwei = function () {
        this.wei = exports.toWei(this.unit, Units.Gwei);
        return this;
    };
    Unit.prototype.asSzabo = function () {
        this.wei = exports.toWei(this.unit, Units.szabo);
        return this;
    };
    Unit.prototype.asFinney = function () {
        this.wei = exports.toWei(this.unit, Units.finney);
        return this;
    };
    Unit.prototype.asEther = function () {
        this.wei = exports.toWei(this.unit, Units.ether);
        return this;
    };
    Unit.prototype.asOne = function () {
        this.wei = exports.toWei(this.unit, Units.one);
        return this;
    };
    Unit.prototype.asKether = function () {
        this.wei = exports.toWei(this.unit, Units.Kether);
        return this;
    };
    Unit.prototype.asMether = function () {
        this.wei = exports.toWei(this.unit, Units.Mether);
        return this;
    };
    Unit.prototype.asGether = function () {
        this.wei = exports.toWei(this.unit, Units.Gether);
        return this;
    };
    Unit.prototype.asTether = function () {
        this.wei = exports.toWei(this.unit, Units.Tether);
        return this;
    };
    Unit.prototype.toWei = function () {
        if (this.wei) {
            return this.wei;
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toKwei = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.Kwei);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toGwei = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.Gwei);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toMwei = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.Mwei);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toSzabo = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.szabo);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toFinney = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.finney);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toEther = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.ether);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toOne = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.one);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toKether = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.Kether);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toMether = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.Mether);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toGether = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.Gether);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toTether = function () {
        if (this.wei) {
            return exports.fromWei(this.wei, Units.Tether);
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toWeiString = function () {
        if (this.wei) {
            return this.wei.toString();
        }
        else {
            throw new Error('error transforming');
        }
    };
    Unit.prototype.toHex = function () {
        if (this.wei) {
            return exports.numberToHex(this.wei);
        }
        else {
            throw new Error('error transforming');
        }
    };
    return Unit;
}());
exports.Unit = Unit;
//# sourceMappingURL=transformers.js.map